import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Legacy /account/user/saved-searches redirected to
 * /collections?tab=searches. Mirror that here.
 */
export const Route = createFileRoute("/_authenticated/account/user/saved-searches")({
  beforeLoad: () => {
    throw redirect({ to: "/account/user/collections", search: { tab: "searches" } });
  },
});
